import { GridColumnMenuFilterUIProps } from "@progress/kendo-react-grid";
import * as React from "react";
import { BranchViewModel } from "./BranchViewModel";
import { CustomFilterUiRadioButton } from "../../Layout/Grid/Filter/CustomFilterUiRadioButton";

export function CarrierBranchFilterUi(
  props: GridColumnMenuFilterUIProps,
  branches: Array<BranchViewModel>
) {
  const values: { label: string; value: any }[] = [];
  [...branches].forEach((b) => {
    values.push({ label: b.Name, value: b.BranchID });
  });
  return <CustomFilterUiRadioButton {...props} values={values} />;
}
